import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { images } from "sweet-assets";
import { EventTypes } from "sweet-global";
import Carousel from "sweet-web/components/universal/Carousel";
import { Label, Title } from "sweet-web/components/universal/Text";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { searchFilter } from "sweet-web/redux/search/actions";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div<{ visible: boolean }>`
  display: ${props => (props.visible ? "flex" : "none")};
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  overflow: visible;
  z-index: 1;
  position: relative;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  pointer-events: ${props => (props.visible ? "auto" : "none")};
  padding-top: 15px;
`;

const ButtonWrapper = styled.div`
  margin-right: 20px;
  width: 220px;
  height: 65px;
  background-color: ${colors.white};
  box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  margin-bottom: 10px;
  &:hover {
    cursor: default;
    transform: scale(1.03);
  }
  @media screen and (max-width: 600px) {
    /* mobile styling */
    width: 100%;
    margin-right: 0;
  }
`;

const ButtonImage = styled.img`
  height: 100%;
  width: 80px;
  object-fit: cover;
`;

const ButtonTitleWrapper = styled.div`
  padding: 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonTitle = styled.h3`
  color: ${colors.nearBlack};
  font-size: 14px;
  font-weight: 600;
`;

type Props = ConnectedProps<typeof connector>;

const Suggestions: React.FC<Props> = props => {
  const EventTypeComponents = EventTypes.map(EventType => {
    const image = images.eventTypes[EventType.name];

    return (
      <ButtonWrapper
        key={`event-type-button-${EventType.name}`}
        onClick={() => {
          props.searchFilter({ eventType: EventType.name });
        }}
      >
        <ButtonImage src={image} />
        <ButtonTitleWrapper>
          <ButtonTitle>{EventType.title}</ButtonTitle>
        </ButtonTitleWrapper>
      </ButtonWrapper>
    );
  });

  return (
    <Wrapper visible={!Boolean(props.eventType)}>
      <Title style={{ marginBottom: 0 }}>
        What can we help you plan{props.firstName ? `, ${props.firstName}` : ""}
        ?
      </Title>
      <Label>We'll show you the best New Haven venues</Label>
      <Carousel>{EventTypeComponents}</Carousel>
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  loggedIn: selectors.loggedIn(state),
  userType: selectors.userType(state),
  firstName: selectors.firstName(state),
  eventType: selectors.searchFilter("eventType")(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      searchFilter
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Suggestions);
